<template>
  <div>
    <v-card class="mt-4 mx-4 elevation-0">
      <!-- // VIEW dialog -->
      <v-dialog v-model="view_dialog" width="900">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>
            {{ view.title }}
          </v-card-title>

          <v-card-text v-html="view.content"> </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click="view_dialog = false">
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- // delete dialog -->
      <v-dialog v-model="delete_dialog" max-width="590">
        <v-card>
          <v-card-title class="headline"
            >Are your sure to delete "<strong>{{ text_to_delete.title }}</strong
            >" Text?</v-card-title
          >

          <v-card-text>
            This Text will be deleted.
          </v-card-text>

          <v-card-actions class="pa-3">
            <div class="flex-grow-1"></div>

            <v-btn color="green darken-1" text @click="delete_dialog_close">
              Cancel
            </v-btn>

            <v-btn
              color="red darken-1"
              text
              @click="deleteText(text_to_delete)"
            >
              Delete Text
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-card class="mx-3 elevation-0">
        <v-card-title class="mx-0 px-0">
          <!-- <v-btn to="/texts/new" dark >Add New Text</v-btn> -->

          <v-layout row mt-3 mx-1>
            <span>
              <v-menu
                offset-y
                :close-on-content-click="true"
                class="text-xs-right mx-4 my-0 py-0 align-center"
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    small
                    icon
                    color="black"
                    dark
                    v-on="on"
                    class="text-xs-right mx-0 mt-2 my-0 py-0"
                  >
                    <v-icon small>supervisor_account</v-icon>
                  </v-btn>
                </template>
                <v-list value="3">
                  <v-list-tile
                    v-for="(item, index) in this.local_text_categories"
                    :key="index.id"
                    @click="toggleCategory(item)"
                  >
                    <!-- <v-list-tile-avatar v-if="item.id==sorting">
                    <v-icon>mdi-sort-ascending</v-icon>
                  </v-list-tile-avatar> -->
                    <!-- <v-list-tile-avatar v-else>
                    <v-icon></v-icon>
                  </v-list-tile-avatar> -->
                    <v-list-tile-title>{{ item.name }}</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </span>
            <span class="text-xs-left mt-2 pt-1 title">
              {{ selectedCategory.name }}
            </span>
            <v-spacer></v-spacer>
          </v-layout>
          <v-spacer></v-spacer>

          <v-btn-toggle v-model="tba21" class="mt-3">
            <!-- NOT WORKING YET -->
            <v-btn
              small
              flat
              key="group0"
              class="px-2"
              input-value="uploads"
              value="uploads"
            >
              <span> Uploads </span>
            </v-btn>
            <v-btn
              small
              flat
              key="group1"
              class="px-2"
              input-value="all"
              value="2"
            >
              <span> All </span>
            </v-btn>
            <v-btn
              small
              flat
              key="group2"
              class="px-2"
              input-value="1"
              value="1"
            >
              <span> TBA21 </span>
            </v-btn>
            <v-btn
              small
              flat
              key="group3"
              class="px-2"
              input-value="0"
              value="0"
            >
              <span> NON TBA21 </span>
            </v-btn>
          </v-btn-toggle>
          <!-- <v-spacer></v-spacer> -->

          <v-text-field
            v-if="this.$store.state.showSearch"
            prepend-inner-icon="search"
            :background-color="search && search.length > 0 ? '#fee' : ''"
            clearable
            label="Search "
            single-line
            hide-details
            class="ml-5"
            v-model="search"
          ></v-text-field>
        </v-card-title>

        <v-data-table
          style="border-top: 1px solid #ccc"
          hide-headers
          :pagination.sync="pagination"
          :headers="headers"
          :items="filtered_texts"
          :search="search"
          v-model="selected"
          item-key="id"
          must-sort
          expand
          :loading="$store.state.loading_texts"
          rows-per-page-text="Texts per page"
          no-results-text="No Texts match the criteria."
          class="elevation-0 pl-0"
        >

          <template slot="items" slot-scope="props">
            <tr :class="{editBG: props.expanded}">
              <td colspan="10" class="px-0">
                <table width="100%" class="px-0">
                  <tr class="px-0">

                    <td
                      rowspan="2"
                      :class="{
                        subheading: true,
                        editBG: props.expanded,
                        title: true,
                        'text-no-wrap px-0': true
                      }"
                      style="padding-bottom:0px; margin-bottom:0px; width: 50px;"
                    >
                      <v-flex v-if="props.item.show_in_texts != 1">
                        <v-btn 
                          class="ml-0 pl-0"
                          icon small
                          @click="viewText(props.item.id)"
                          ><v-icon small>remove_red_eye</v-icon></v-btn
                        >
                        <v-btn @click="download_text(props.item)" small icon class="mr-1">
                          <v-icon small color="black">mdi-download</v-icon>
                        </v-btn>
                        <v-btn
                          small
                          icon
                          @click="showArtworks(props)"
                          :disabled="!props.item.artworks.length > 0"
                        >
                          <v-icon small
                            :color="
                              props.expanded && showingArtworks
                                ? 'red'
                                : props.item.artworks &&
                                  props.item.artworks.length > 0
                                ? 'black'
                                : 'grey'
                            "
                            >photo_library</v-icon
                          >
                        </v-btn>
                        <v-btn
                          class="mr-3"
                          small
                          icon
                          @click="showArtists(props)"
                          :disabled="!props.item.artists.length > 0"
                        >
                          <v-icon small
                            :color="
                              props.expanded && !showingArtworks
                                ? 'red'
                                : props.item.artists &&
                                  props.item.artists.length > 0
                                ? 'black'
                                : 'grey'
                            "
                            >people</v-icon
                          >
                        </v-btn>
                      </v-flex>
                      
                      <v-flex v-else>
                        <a href="" @click.prevent="downloadFile(`/data/${props.item.category}/${id(props.item)}/${props.item.fname}`, props.item.fname)">
                          <v-btn small icon>
                            <v-icon color="black" >download</v-icon >
                          </v-btn>
                        </a>
                      </v-flex>
                    </td>

                    <td
                      colspan="2"
                      :class="{ 'layout align-end justify-space-between pr-1 fill-height': true, editBG: props.expanded }"
                    >
                      <span class="mt-0 title">
                        <a v-if="props.item.show_in_texts"
                          href=""
                          @click.prevent="downloadFile(`/data/${props.item.category}/${id(props.item)}/${props.item.fname}`, props.item.fname)"
                          style="font-weight: 500; color:#392939;"
                          >{{ props.item.name ? props.item.name : props.item.fname }}</a
                        >

                        <router-link v-else
                          class="mr-3 multi-line"
                          :to="{
                            name: 'EditText',
                            params: {
                              id: props.item.id,
                              editedItem: props.item
                            },
                            path: `/texts/edit/${props.item.id}`
                          }"
                        >
                          <span v-if="props.item.given_filename">
                            {{ stripHtml(props.item.given_filename) }} 
                          </span>
                          <span v-else> NO TITLE </span>
                        </router-link>
                      </span>

                      <span class="grey--text right pb-1 pr-0">
                        <small
                          >{{ format_date(props.item.created_at) }}</small
                        >
                        <small v-if="props.item.created_by"
                          >BY <b>{{ get_abb(props.item.created_by) }}</b></small
                        >
                        <!-- <small v-if="props.item.updated_at"
                          >LAST UPDATE:
                          <b>{{ format_date(props.item.updated_at) }}</b></small
                        > -->
                      </span>                      
                    </td>

                  </tr>
                  
                  <tr>
                    <td  colspan="3" class="layout  align-center justify-space-between fill-height pr-0">
                      <span  v-if="props.item.show_in_texts == 1">{{ getRelatedTitle(props.item)}}</span>
                      <span  v-else>
                        <small>{{ snake2title( categoryName(props.item.category) ).toUpperCase() }}</small>
                      </span>
                    <!-- </td> -->
                  <!-- </tr> -->
                  
                  <!--tr  class="blue">
                    <td></td> -->
                    <!-- <td>{{ props.item.fname }}</td> -->
                    <!-- <td
                      :class="{
                        'pt-0 grey--text text-xs-right subheading': true,
                        editBG: props.expanded
                      }"
                    >
                      <small
                        >{{ format_date(props.item.created_at) }}</small
                      >
                      <small v-if="props.item.created_by"
                        >BY <b>{{ get_abb(props.item.created_by) }}</b></small
                      >
                      <small v-if="props.item.updated_at"
                        >LAST UPDATE:
                        <b>{{ format_date(props.item.updated_at) }}</b></small
                      >
                    </td>
                    <td :class="{  editBG: props.expanded }">
                    </td> -->
                    <span 
                      :class="{
                        'right': true,
                        subheading: true,
                        editBG: props.expanded
                      }"
                    >
                      <v-chip small right v-if="props.item.publication" >publication</v-chip >
                      <v-chip small right v-if="props.item.article">article</v-chip>
                      <v-chip small right v-if="props.item.artwork_text" >text on artwork</v-chip >
                      <v-chip small right v-if="props.item.artist_documents" >artist documents</v-chip >
                      <v-chip small right v-if="props.item.pr">PR</v-chip>
                      <v-chip small right v-if="props.item.transcript" >transcript</v-chip >
                      <v-chip small right v-if="props.item.work_text" >work text</v-chip >
                    </span>
                    </td>
                  </tr>
                
                </table>

              </td>
            </tr>
            <!-- <td>{{ props.item.artwork_id }}</td>
          <td>{{ props.item.pr ? "YES" : "NO" }}</td>
          <td>{{ props.item.article ? "YES" : "NO" }}</td>
          <td>{{ props.item.artwork_text ? "YES" : "NO" }}</td>
          <td>{{ props.item.artist_documents ? "YES" : "NO" }}</td>
          <td>{{ props.item.transcript ? "YES" : "NO" }}</td>
          <td>{{ props.item.work_text ? "YES" : "NO" }}</td> -->
            <!-- </tr> -->
            <!-- </table> -->

            <!-- </td> -->
            <!-- <td
            style="width:30px;"
            :class="{
              'text-xs-right': true,
              editBG: props.expanded,
              'pr-0': true,
              'mr-0': true
            }"
          >
            <v-btn
              small
              dark
              @click="props.expanded = !props.expanded"
              v-if="props.item.artworks.length > 0"
            >
              show artworks
              <v-icon v-if="props.expanded">expand_more</v-icon>
              <v-icon v-if="!props.expanded">expand_less</v-icon>
            </v-btn>
          </td>
          <td class="pr-0 mr-0">
            <v-tooltip top v-if="c_user.delete_rights">
              <template #activator="data">
                <span v-on="data.on">
                  <v-btn
                    style="width:20px; height:20px"
                    round
                    color="red"
                    icon
                    small
                    dense
                    @click="deleteText(props.item)"
                    hint="Delete text"
                  >
                    <v-icon small dense color="white">remove</v-icon>
                  </v-btn>
                </span>
              </template>
              Delete Text
            </v-tooltip>
          </td> -->
          </template>

          <template v-slot:expand="props">
            <v-flex
              style="background-color:#eee; color: #444;"
              class="px-3 py-1 my-0 elevation-0 xs12"
            >
              <h3
                v-if="showingArtworks"
                class="font-weight-bold red--text subtitle xs12 pl-1 ml-0 pb-0 flex"
              >
                ARTWORKS
              </h3>
              <h3
                v-else
                class="font-weight-bold red--text subtitle xs12 pl-1 ml-0 pb-0 flex"
              >
                ARTISTS
              </h3>
            </v-flex>
            <ListRelated
              v-if="showingArtworks"
              :artworks="props.item.artworks"
              :text_id="props.item.id"
            ></ListRelated>
            <ListRelatedArtists
              v-else
              :artists="props.item.artists"
              :text_id="props.item.id"
            ></ListRelatedArtists>
            <v-flex
              style="background-color:#292929; color: #eee;"
              class="px-3 py-1 my-0 elevation-0 xs12"
            >
              <h3 class="font-weight-bold subtitle xs12 flex">&nbsp; &nbsp;</h3>
            </v-flex>
          </template>

          <v-alert slot="no-results" :value="true" color="error" icon="warning">
            Your search for "{{ search }}" found no results.
          </v-alert>
          <template slot="no-data">
            <index-load-state
              :loading="$store.state.loading_texts"
              :error="$store.state.load_errors.texts"
              empty-text="No Texts Found."
            ></index-load-state>
          </template>
        </v-data-table>
      </v-card>
    </v-card>
  </div>
</template>

<script>
import { serverBus } from '../../main'
import axios from '@/utils/apiClient'
import { downloadAuthenticatedFile } from '@/utils/authenticatedFile'
import ListRelated from './ListRelated'
import ListRelatedArtists from './ListRelatedArtists'
import constants from '@/data/constants'
import IndexLoadState from '@/components/general/IndexLoadState.vue'

export default {
  data() {
    return {
      constants: constants,
      filtered: [],
      // selectedCategoryName: '',
      selectedCategory: {},
      local_text_categories: [],
      progress: false,
      showingArtworks: false,
      showingArtists: false,
      view_dialog: false,
      view: {},
      table_texts: [],
      text_to_delete: '',
      delete_dialog: false,
      delete_step: 0,
      pagination: {
        descending: false,
        rowsPerPage: 10,
        sortBy: 'given_filename'
      },
      relatedShown: [],
      fields: ['artwork_location_id', 'type_of_work_id'],
      dialog: false,
      ta: [],
      selected: [],
      tba21: '1',
      search: 'dd', // this.$store.state.searchString['texts'],
      headers: [
        // { text: "", sortable: false, value: "" },
        { text: 'File Name', sortable: true, value: 'given_filename' },
        // { text: "File Name", sortable: true, value: "fname" },
        // { text: "Title", align: "left", sortable: true, value: "title" },
        { text: '', value: 'artwork_text', sortable: false },
        { text: 'Date Created', sortable: true, value: 'created_at' },
        { text: 'Created by', sortable: true, value: 'created_by' },
        { text: 'Date Last Modified', sortable: true, value: 'updated_at' },
        { text: 'Type of text', sortable: true, value: 'category' },
        { text: '', value: 'fname', sortable: false },
        { text: '', value: 'given_filename', sortable: false },
        { text: '', value: 'artwork_text', sortable: false }
        // { text: "Artwork", sortable: true, value: "artwork_id" },
        // { text: "PR", sortable: true, value: "pr" },
        // { text: "Article", sortable: true, value: "article" },
        // { text: "Artw. Text", sortable: true, value: "artwork_text" },
        // { text: "Artist Doc.", sortable: true, value: "artist_documents" },
        // { text: "Transcript", sortable: true, value: "transcript" },
        // { text: "", sortable: false }
      ]
    }
  },
  // props: ["items"],
  // watch: {
  //   search: function() {
  //   }
  // },
  beforeRouteLeave(to, from, next) {
    // this.$store.commit('routeChange')
    this.$store.dispatch('setSearchString', {
      string: this.search,
      section: 'texts'
    })
    next()
  },
  created: function() {
    // console.log('created')
    // console.log(this.$store.state.searchString['texts'])
    this.setsearchvalue()
    this.$store.dispatch('loadTexts')
    this.table_texts = this.$store.state.texts
    this.local_text_categories = Object.assign(
      [],
      this.constants.TEXT_CATEGORIES
    )
    this.local_text_categories.unshift({ id: 'all', name: 'All' })
    this.toggleCategory(this.local_text_categories[0])
  },
  mounted: function() {
    // console.log('mounted')
    // console.log(this.$store.state.searchString['texts'])
    this.setsearchvalue()
    serverBus.$on('setSorting', a => {
      this.pagination.sortBy = a
      this.pagination.descending = !this.pagination.descending
    })
    // this.$store.dispatch("loadTexts");
    this.table_texts = this.$store.state.texts
  },
  methods: {
    download_text(text) {
      console.log(text)
      // this.exportHTML(text, this.artwork)
      this.exportHTML(text.content, text.given_filename ? text.given_filename : text.title)
    },
    getRelatedTitle(text) {
      // console.log(text)
      switch (text.category) {
        case 'artwork_literature' || 'artwork_text':
          var o = this.$store.state.artworks.find(a => a.id == text.artwork_id)
          return o ? `${o.title}, ${o.accession_number}` : 'Artwork not found'
          break;
        case 'artist_interview' || 'artist_press' || 'artist_text':
          var o = this.$store.state.artists.find(a => a.id == text.artist_id)
          return o ? o.name : 'Artist not found'
          break;      
        default:
          return 'Article File from Old TBA21 Website'
          break;
      }
    },
    controller(category) {
      return ['artist_interview','artist_press','artist_text'].includes(category) ? 'artists' : (category == 'artwork_literature' ? 'artworks' : 'articles')
    },
    id(item) {
      return ['artist_interview','artist_press','artist_text'].includes(item.category) ? item.artist_id : (item.category == 'artwork_literature' ? item.artwork_id : item.article_id)
    },
    setsearchvalue() {
      this.search = this.$store.state.searchString['texts']
    },
    toggleCategory(o) {
      // this.selectedCategoryName = o.name;
      this.selectedCategory = o
      // if(o.id != 'all') {
      //   this.filtered = this.filtered_texts.filter(a => a[o.id] == 1);
      // } else {
      //   this.filtered = this.filtered_texts;
      // }
    },
    categoryName(c) {
      var cs = {
        artwork_literature: 'ARTWORK TEXT OLD CMS',
        artwork_text: 'ARTWORK TEXT NEW CMS'
      }
      // console.log(cs[c])
      if (cs) {
        return cs[c] ? cs[c] : c
      } else {
        return ''
      }
    },
    showArtworks(props) {
      props.expanded = !props.expanded
      this.showingArtworks = true
    },
    showArtists(props) {
      props.expanded = !props.expanded
      this.showingArtworks = false
    },
    viewText(id) {
      this.progress = true
      let url = `${this.$globals.apiserver}/artwork_texts/${id}.json`
      var atext = {}
      axios
        .get(url)
        .then(response => {
          atext = response.data
          this.progress = false
          // console.log(atext)

          RegExp.escape = function(atext) {
            return atext.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&')
          }
          if (this.search) {
            let content = atext.content.replace(
              new RegExp(this.search, 'gi'),
              match => `<mark>${match}</mark>`
            )
            let title = atext.title.replace(
              new RegExp(this.search, 'gi'),
              match => `<mark>${match}</mark>`
            )
            this.view.title = title
            this.view.content = content
          } else {
            this.view = atext
          }
          this.view_dialog = true
        })
        .catch(error => {
          console.log(error)
        })
      this.progress = false
    },
    delete_dialog_close() {
      this.delete_dialog = false
      this.delete_step = 0
    },
    deleteText(e) {
      if (this.delete_step == 0) {
        this.delete_dialog = true
        this.delete_step = 1
        this.text_to_delete = e
      } else {
        this.$store.dispatch('deleteText', e)
        this.delete_dialog = false
        this.delete_step = 0
        // console.log('deleted')
      }
    },
    async downloadFile(path, filename) {
      try {
        await downloadAuthenticatedFile(this.$globals.fileserver, path, filename)
      } catch (error) {
        console.warn('Unable to download authenticated file', error)
      }
    },
    showRelated(id) {
      if (this.relatedShown[id] == true) {
        this.relatedShown[id] = false
      } else {
        this.relatedShown[id] = true
      }
      // console.log(this.relatedShown)
    },
    addField() {},
    switchSwitch() {
      // this.show_tag_filter = !this.show_tag_filter
      this.$emit('switchOwnershipTop', this.show_tag_filter)
    },
    clearFilters() {
      this.selected_tags = []
      this.selected_tag_categories = []
    }
  },
  computed: {
    filtered_texts() {
      let filtered = []
      if (this.tba21 == 'uploads') {
        filtered = this.$store.state.file_uploads.filter(
          fu => fu.show_in_texts == 1
        )
      } else {
        filtered = this.$store.state.texts.filter(
          t => t.category != 'artwork_exhibition'
        )
      }
      if (this.selectedCategory.id != 'all') {
        filtered = filtered.filter(a => a[this.selectedCategory.id] == 1)
      }
      if (this.tba21 == 1) {
        filtered = filtered.filter(e => e.tba == 'tba')
      } else if (this.tba21 == 0) {
        filtered = filtered.filter(e => e.tba == 'nontba')
      }
      // let out = [];
      // console.log(filtered)
      // console.log(filtered[0])
      // filtered.forEach(te => {
      //   te = Object.assign({}, te);
      //   let aids = te.artworks.map(tea => tea.id);
      //   let sas = Object.assign([], this.$store.state.artworks);
      //   // console.log('aidss')
      //   // console.log(aids)
      //   let as = Object.assign(
      //     [],
      //     sas.filter(a => aids.includes(a.id))
      //   );
      //   // let artistsids = te.artists.map(tea => tea.id);
      //   // let sars = Object.assign([], this.$store.state.artists)
      //   // // console.log('aidss')
      //   // // console.log(aids)
      //   // let ars = Object.assign(
      //   //   [],
      //   //   sars.filter(a => artistsids.includes(a.id))
      //   // );
      //   // console.log('as')
      //   // console.log(as)
      //   te.artwork_text = as
      //     .map(
      //       aa =>
      //         `${aa.accession_number} ${aa.title} ${aa.name} ${aa.artist_name}`
      //     )
      //     .toString();
      //   // console.log('te.artwork_text')
      //   // console.log(te.artwork_text)
      //   out.push(te);
      // });
      // console.log(out)
      return filtered
      // return filtered;
    },
    add_new: {
      get() {
        return this.$store.state.add_new
      },
      set(value) {
        this.$store.dispatch('addNew', value)
      }
    },
    currrent_path() {
      return this.$route.params.ownership
    }
    // table_texts () {
    //   // if (this.selected_tags.length > 0) {
    //   //   var cst = this.selected_tags
    //     return this.$store.state.texts
    //     // .filter(function(artwork) {
    //   //     return artwork.tags.some(a_tag => cst.indexOf(a_tag.id) > -1)
    //   //   })
    //   // } else {
    //     // console.log('items')
    //     // return this.items
    //     // $store.state.artworks
    //   // }
    // },
  },
  components: { ListRelated, ListRelatedArtists, IndexLoadState }
}
</script>

<style scoped>
td {
  height: 28px !important;
}
a {
  text-decoration: none;
  color: #333;
}
/* a:hover {text-decoration: underline; color: #000} */
h3 a:hover {
  text-decoration: underline;
  color: #000;
}
/*.hoverDetect:hover img {
      -webkit-transform: scale(3);
      -moz-transform: scale(3);
      -ms-transform: scale(3);
      transform: scale(3); */
/* -webkit-transition: -webkit-transform .1s ease-out;
      -webkit-transition: transform .1s ease-out;
      -moz-transition: transform .1s ease-out;
      transition: transform .1s ease-out; */
/* } */
.multi-line {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  /* background-color: #a6a9ab; */
}
/* table.v-table thead td:not(:nth-child(1)), 
table.v-table tbody td:not(:nth-child(1)), 
table.v-table thead th:not(:nth-child(1)), 
table.v-table tbody th:not(:nth-child(1)), 
table.v-table thead td:first-child, 
table.v-table tbody td:first-child, 
table.v-table thead th:first-child, 
table.v-table tbody th:first-child {
    padding: 0px !important;
}
table.v-table tbody td,
table.v-table tbody td:first-child,
table.v-table tbody th {
  height: 20px;
  padding-left: 0px;
  padding-top: 0px;
  /* padding-bottom: 4px; */
/*} */

h2 {
  padding: 20px 0 0 20px;
  font-weight: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/texts/Index.vue